import React from 'react';
import { Container } from './Container';
import { Button, ButtonModes } from './Button';

const amounts = [
  [100, '100zł'],
  [55, '55zł'],
  [35, '35zł'],
  [25, '25zł'],
  [15, '15zł'],
  [60, 'Inna kwota'],
];

export const Donate = () => (
  <Container>
    <div className="donate-extended">
      <h3>
        Wpłacam na
        {' '}
        <wbr />
        wsparcie partii
      </h3>
      <div className="donate-extended__amounts">
        {amounts.map(([number, label]) => (
          <div
            key={number}
            className="donate-extended__amounts__item"
          >
            <Button
              mode={ButtonModes.secondary}
              key={number}
              url={`https://wesprzyj.partiarazem.pl/platnosc?amount=${number}`}
              newWindow
            >
              {label}
            </Button>
          </div>
        ))}
      </div>
    </div>
  </Container>
);

interface SimpleDonateProps {
  cta: string,
  text: string,
}

export const DonateSimple = (props: SimpleDonateProps) => (
  <div className="donate-simple">
    <div className="donate-simple__content">
      <div className="donate-simple__text">{props.text}</div>
      <div className="donate-simple__button">
        <Button
          mode={ButtonModes.primary}
          url="https://wesprzyj.partiarazem.pl"
          newWindow
        >
          {props.cta}
        </Button>
      </div>
    </div>

  </div>
);

interface DonateWithPhotoProps {
  cta: string,
  text: string,
  color?: string,
  image: string,
}

export const DonateWithPhoto = (props: DonateWithPhotoProps) => {
  const color = props.color || '#B81476';
  return (
    <div className="donate-with-photo">
      <img className="donate-with-photo__photo" src={props.image} alt="Fotografia do przycisku wsparcia partii" />
      <div className="donate-with-photo__content">
        <div className="donate-with-photo__text" style={{ color }}>{props.text}</div>
        <div className="donate-with-photo__button">
          <Button
            mode={ButtonModes.primary}
            url="https://wesprzyj.partiarazem.pl"
            newWindow
            color={color}
          >
            {props.cta}
          </Button>
        </div>
      </div>
    </div>
  );
};
